export default {
    logged: {
        title: '多元投资香港科技券商 TOP1',
        subTitle: '一站式投资全球',
        desc1: '复星国际（00656.HK）旗下，AI 驱动的 WEB5（WEB2+WEB3）综合券商。',
        desc2: '持香港证监会颁发的1、2、4、6、9号牌照，首批获得香港虚拟资产交易服务牌照券商。',
        desc3: '港美股、A股、加密货币、基金、债券、票据、RWA代币化产品等应有尽有。',
        ljkh3m: '3分钟极速开户',
        zjjsqz: '最终解释权归复星财富控股所有',
        kh: '开户',
        rj: '入金',
        kt: '开启投资',
        lddesc1: '一站式投资全球，投资品类全覆盖，产品丰富度香港科技券商TOP1。',
        lddesc2: '复星国际（00656.HK）旗下，AI 驱动的 WEB5（WEB2+WEB3）综合券商。',
        lddesc3: '持香港证监会颁发的1、2、4、6、9号牌照，首批获得香港虚拟资产交易服务牌照券商。',
        user: '用户',
        getReward: '获得了开户$0佣金奖励',
        gpmgqyj: '港美股/期权永久',
        yj: '佣金',
        xsslyj1000hkd: '限时领 1000+HKD 奖赏',
        star: '星',
    },
    pageTitle: '复星国际证券开户',
    title1: '0门槛',
    title2: '3分钟极速开户',
    oneAccount: '一个账户投资全球',
    advantage: '复星国际证券优势',
    advantage1: '新人福利',
    des1: '开户立享多重礼',
    advantage2: '交易便捷',
    des2: '支持快捷改单',
    advantage3: '港股打新',
    des3: '最高33倍融资',
    advantage4: '电子暗盘',
    des4: '成交快人一步',
    advantage5: '孖展账户',
    des5: '支持融资交易',
    advantage6: '免费行情',
    desLV2: '港股LV2高级行情',
    desLV1: '美股LV1高级行情',
    hkLv2: '港股LV2高级行情',
    usLv1: '美股LV1高级行情',
    usdes: '美股LV1串流报价',
    advantage7: '资质合规',
    des7: '持香港证监会颁发 1/2/4/6/9号牌照',
    advantage8: '品牌可靠',
    des8: '复星旗下 中国民营企业500强前50名',
    btnText: '立即开户',
    btnText2: '立即下载',
    btnText3: '立即参与',
    thsTip: '您有未完成的开户流程，请使用浏览器访问以下链接继续完成开户',
    organTip: '该手机号已绑定交易账户，该类型账户即将开放线上交易功能，敬请期待！',
    confirm: '确定',
    cancel: '取消',
    know: '知道了',
    ndkhywc: '您的开户已完成',
    hcydjwckhl: '还差一点就完成开户啦！<br/>请继续填写资料，完成开户。',
    jvkh: '继续开户',
    isLogin: '已有账户？直接登录',
    tip: '提示',
    openAccountStrictContent: {
        confirmButtonText: '切换开户方式',
        tip1: '非常抱歉，目前无法为中国境内投资者提供开户服务，您可以通过网上转账开户继续开通证券账户',
        tip2: '非常抱歉，目前无法为中国境内投资者提供开户服务',
        tip3: '温馨提示：切换开户方式，您当前的开户申请将会失效',
        tip5: '请前往星财富APP继续完成开户',
        tip6: '请授权使用您当前的位置后再继续进行开户',
        gotoAppBtn: '立即前往',
        gotoSettingBtn: '去设置',
        getAppLocationToastMessage: '获取中...',
    },
    mrStatus: {
        tip: {
            span1: '为提升系统体验，正在进行',
            span2: '系统维护',
            span3: '。开户、出入金、换汇、提交订单等操作将受影响无法使用。同时，系统可能不能正常查询您的资金、持仓、交易历史等，待系统维护后会恢复正常。如对阁下造成不便，为此深表歉意。',
        },
    },

    一站式全球财富管理平台: '一站式全球财富管理平台',
    '覆盖港股、美股、沪深港通全球主要市场': '覆盖港股、美股、沪深港通全球主要市场',
    '基金、债券、另类投资应有尽有': '基金、债券、另类投资应有尽有',
    存款方式多样化: '存款方式多样化',
    支持eDDA快速存款: '支持eDDA快速存款',
    '支持转数快、银行转账等提供安全便捷等快速入金服务': '支持转数快、银行转账等提供安全便捷等快速入金服务',
    tips: '温馨提示',
    promptText: '系统识别到当前手机号具备未完成的企业户开户任务，请前往Web版完成企业开户。',
    openAccountLimitPopInfo: {
      title: '内地投资者开户声明',
    },
    openProtocolContent: {
      first: '本人已阅读、理解并同意',
      second: '内地投资者开立投资账户声明及同意条款',
      third: '全部声明内容,确认自愿签署',
    },
    agreementAndItems: {
      first: '本人同意',
      second: '电子签名的同意书',
      thirt: '，通过输入交易密码及一次性短信验证码等电子方式,以进行',
      fourth: '内地投资者开立投资账户声明及同意条款',
      fifth:
        '确认及签署文件。本人明白此电子签署方式符合香港《电子交易条例》(第553章)规定,并与本人亲笔签名具有同等法律效力',
    },
    signErrorTxt: '签署失败，稍后重试',
}
